<template>
	<div class="header_container">
        <!-- <el-row>
            <el-col :span="20" class="title">
                <div class="title-content">TCL Alexa Console </div>
            </el-col>

            <el-col :span="2" class="user-info">
                <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                        用户名<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="userInfo">个人信息</el-dropdown-item>
                        <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>

            <el-col :span="1" class="message">
                <el-badge :value="2" class="item">
                    <el-button type="text" @click="checkMessage">通知</el-button>
                </el-badge>
            </el-col>

            <el-col :span="1" class="logout">
                <el-button type="text" @click="logout">退出</el-button>
            </el-col>
        </el-row> -->

        <el-container style="text-align: right; width: 100%">
			<img src="@/assets/console2.png" width="60" height="60" style="margin-top: 20px; margin-left: 20px">
            <div class="title-content" style="margin: 20px 10px;">TCL Alexa Console </div>

            <div style="height: 100%; width: 20%; position:absolute; right:1%;">
                <el-dropdown @command="handleCommand" style="margin: 20px 10px; padding-top: 2px;" v-if="this.user.email !== undefined ">
                    <span id="title_username" class="el-dropdown-link">
                        用户名<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--el-badge :value="5" class="item" style="margin: 20px 10px;">
                    <el-button type="text" @click="checkMessage">通知</el-button>
                </el-badge-->
                <el-button type="text" @click="logout" style="margin-left: 10px;">退出</el-button>
            </div>

           
        </el-container>


        <!-- 修改密码界面 -->
		<!--el-dialog title="修改密码" :visible.sync="modifyPwdFormVisible" class='modify' width='480px'-->
		<el-dialog :title="changePwdTitle" v-model="modifyPwdFormVisible" :visible.sync="modifyPwdFormVisible"
				   :close-on-click-modal="false" size="tiny" align="center" width='480px'>
			<el-form :model="modifyPwdForm" :rules="rules" ref="modifyPwdForm" align="left">
				<el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPwd">
					<el-input placeholder="请输入旧密码" type="password" v-model="modifyPwdForm.oldPwd" auto-complete="off" style="width: 350px"></el-input>
				</el-form-item>
				<el-form-item label="新密码" :label-width="formLabelWidth" prop="newPwd">
					<el-input placeholder="请输入新密码" type="password" v-model="modifyPwdForm.newPwd" auto-complete="off" style="width: 350px"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码" :label-width="formLabelWidth" prop="checkNewPwd">
					<el-input placeholder="请确认新密码" type="password" v-model="modifyPwdForm.checkNewPwd" auto-complete="off" style="width: 350px"></el-input>
				</el-form-item>
				<el-form-item id="button" align="center">
					<el-button @click="cancelForm('modifyPwdForm')">取 消</el-button>
					<el-button type="primary" @click="submitForm('modifyPwdForm')">提 交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import { Message } from 'element-ui'

import { USER_LOGOUT } from '@/store/modules/user'
import { Config } from '@/config/config'
import { ERROR_OK } from "@/const/consts";
import Notify from '../api/notifyMsg'

export default {
    name: 'Head',
    computed: mapState({
        user: state => state.user
    }),
    data() {
        var validateOldPwd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入旧密码'));
            } else {
                callback();
            }
        };
        var validateNewPwd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入新密码'));
            } else {
                callback();
            }
        };
        var validateCheckNewPwd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value !== this.modifyPwdForm.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            // serverItems: [],
            modifyPwdFormVisible: false,
            modifyPwdForm: {
                oldPwd: '',
                newPwd: '',
                checkNewPwd: ''
            },
            changePwdTitle: '修改密码',
            formLabelWidth: '90px',
            rules: {
                oldPwd: [
                    { validator: validateOldPwd, trigger: 'blur' }
                ],
                newPwd: [
                    { validator: validateNewPwd, trigger: 'blur' }
                ],
                checkNewPwd: [
                    { validator: validateCheckNewPwd, trigger: 'blur' }
                ]
            },
        }
    },
    components: {

    },
	mounted() {
		//console.log("user:", this.user, this.user.email)
        this.updateHeader();
	},
    methods: {
        ...mapActions([USER_LOGOUT]),
        logout() {
            Message.info({message: '注销登录', showClose: true});
            /*this.USER_LOGOUT().then(data => {
                if (data.ErrorCode == ERROR_OK) {
                    this.$router.replace({ path: '/console/login/' })
                }
            }).catch(err => {
                console.log(err)
            })*/
            this.USER_LOGOUT();
            this.$router.replace({path: '/console/login'});
            
            // this.$confirm('确定注销登录吗?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning',
            //         center: true
            //     }).then(() => {
            //         this.USER_LOGOUT()
            //         this.$router.replace({ path: '/login' })
            //     }).catch(() => {
            //         Message.info({message:"已取消注销"})
            // });
        },
        updateHeader() {
            document.getElementById("title_username").innerHTML = this.user.email;
        },
		checkMessage() {
				Message.success({message: '查看消息', showClose: true});
		},
        handleCommand(command) {
            //Message.info({message: 'click on item ' + command});
            this.handlePwdModify()
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath)
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath)
        },
        handlePwdModify() {
            this.modifyPwdFormVisible = true
        },
        cancelForm(formName) {
            this.modifyPwdFormVisible = false
            this.$refs[formName].resetFields()
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.pwdModify(formName)
                } else {
                    console.log('error submit!!')
                    return false;
                }
            })
        },
        pwdModify(formName) {
            var _this = this
            this.modifyPwdFormVisible = false
            var fetchOptions = {
                method: 'POST',
                body: JSON.stringify(
                {
                    "Oldpassword": _this.modifyPwdForm.oldPwd,
                    "Newpassword": _this.modifyPwdForm.newPwd
                })
            }

            fetch(Config.url + "/api/v1/users/:" + this.user.UID + "?token=" + this.user.token , fetchOptions)
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json.Error_code === 1000) {
                    this.$message({
                        type: 'success',
                        message: '密码修改成功！'
                    });
                } else {
                    console.log("error!")
                    Notify.errMsgNotify(json.Error_code, this)
                    return
                }
            })
            this.$refs[formName].resetFields();
        }
    }
}
</script>

<style>
.header_container{
    #background-color: #0288d1;
    #color: #c0ccda;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue